<template>
  <div>
    <transition name="slide-fade">
      <div class="loading-integreat disablePrint" v-if="isLoadingPage">
        <div class="initial-load-animation">
          <div class="linkedin-image"></div>
          <div class="loading-bar">
            <div class="blue-bar"></div>
          </div>
        </div>
      </div>
    </transition>
    <div
      class="detail-table page th pd-15 printPadding has-text-centered"
      v-if="dataReport == ''"
    >
      <p
        class="has-text-drak is-size-6 th is-padding-x has-text-centered has-text-centered"
      >
        *** {{ $t("smartReport.notFound") }} ***
      </p>
    </div>
    <div v-else class="detail-table is-block page th pd-15 printPadding">
      <div class="has-text-right">
        <p class="has-text-grey is-size-7 th">
          <i>{{ $t("message.updatedAt") }} {{ formatTime(dateNow) }}</i>
        </p>
      </div>
      <table>
        <tr>
          <td>
            <p>
              <img
                alt="logo name"
                style="max-width: 160px"
                v-if="under.underLogo"
                class=""
                :src="imgUrlUnder + under.underLogo"
              />
              <img
                alt="logo name"
                style="max-width: 160px"
                v-else
                class=""
                :src="imgUrlUnder + 'inteGreat.png'"
              />
            </p>
          </td>
          <td>
            <h2 class="has-text-weight-normal is-size-4">
              {{ $t("smartReport.smartReportDetail") }}
            </h2>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.reportDetailBatchName") }}:
              <span>{{ dataReport.batchName }}</span>
            </p>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.reportDetailFiscalYear") }}:
              <span>{{ dataReport.fiscalYear }}</span>
            </p>
            <p
              class="has-text-weight-normal"
              v-if="
                getRule == 'staff' || getRule == 'startup' || getRule == 'admin'
              "
            >
              {{ $t("smartReport.reportDetailBy") }}:
              <span>{{ dataReport.scienceParkName }}</span>
            </p>
            <p class="has-text-weight-normal" v-else>
              {{ $t("smartReport.reportDetailBy") }}:
              <span>{{ allScience.name }}</span>
            </p>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.reportDetailAgencyUnder") }}:
              <span :class="spaPage == 'spa' ? 'color-orange' : 'done-color'">{{
                under.name
              }}</span>
            </p>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.reportDetailOperationPeriod") }}:
              <span
                >{{ dateFomat(dataReport.rangeStartDate) }}
                {{ $t("smartReport.to") }}
                {{ dateFomat(dataReport.rangeEndDate) }}</span
              >
            </p>
          </td>
        </tr>
      </table>
      <div class="mg-y-25">
        <p class="bg-title-report">
          <span>{{ $t("smartReport.sessionOne") }}</span>
        </p>
      </div>
      <table>
        <tr>
          <td>
            <p>
              <img
                alt="logo organize"
                style="max-width: 160px"
                class=""
                :src="imgUrl + dataReport.company.organizeLogo"
              />
            </p>
          </td>
          <td>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.sessionOneName") }}:<span
                class="has-text-weight-light"
                v-if="dataReport != ''"
              >
                {{ dataReport.company.nameOfBusiness }}</span
              >
            </p>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.sessionOneBusinessType") }}:<span
                class="has-text-weight-light"
              >
                {{ businessType }}</span
              >
            </p>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.sessionOneLevelBusiness") }}:<span
                class="has-text-weight-light"
              >
                {{
                  getLevelOfBusiness(dataReport.company.levelOfbusiness)
                }}</span
              >
            </p>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.sessionOneAddress") }}:<span
                class="has-text-weight-light"
              >
                {{ dataReport.company.address }}
                {{ $t("userDetail.businessDistrict")
                }}{{ dataReport.company.cityDistrict }}
                {{ $t("userDetail.businessProvince")
                }}{{ dataReport.company.province }}
                {{ dataReport.company.postcode }}
                {{ $t("userDetail.businessCountry")
                }}{{ dataReport.company.country }}
              </span>
            </p>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.sessionOneTelephone") }}:<span
                class="has-text-weight-light"
              >
                {{ dataReport.company.telephoneNumber }}</span
              >
            </p>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.sessionOneEmail") }}:<span
                class="has-text-weight-light"
              >
                {{ dataReport.company.email }}</span
              >
            </p>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.sessionOneCompanyNo") }}:<span
                class="has-text-weight-light"
              >
                <span
                  v-if="
                    dataReport.CompanyRegistrationNumber != '' &&
                    dataReport.CompanyRegistrationNumber != null &&
                    typeof dataReport.CompanyRegistrationNumber != 'undefined'
                  "
                  >{{ dataReport.CompanyRegistrationNumber }}</span
                >
                <span v-else> -</span>
              </span>
            </p>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.sessionOneRegisDate") }}:
              <span
                v-if="
                  dataReport.companyDateRegister != '' &&
                  dataReport.companyDateRegister != null &&
                  typeof companyDateRegister != 'undefined'
                "
                class="has-text-weight-light"
              >
                {{ dateFomat(dataReport.companyDateRegister) }}</span
              >
              <span v-else class="has-text-weight-light"> -</span>
            </p>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.sessionOneCapital") }}:

              <span
                class="has-text-weight-light"
                v-if="dataReport.companyFund > 0"
              >
                {{ dataReport.companyFund | commaNumber }}
                {{ $t("message.batch") }}</span
              >
              <span v-else class="has-text-weight-light">
                - {{ $t("message.batch") }}</span
              >
            </p>
            <p class="has-text-weight-normal">
              {{ $t("smartReport.sessionOneBatchJoin") }}:<span
                class="has-text-weight-light"
              >
                {{ dateFomat(dataReport.company.contractDate) }}</span
              >
            </p>
          </td>
        </tr>
      </table>
      <div class="mg-y-25">
        <p class="bg-title-report">
          <span>{{ $t("smartReport.sessionTwo") }}</span>
        </p>
      </div>
      <table class="">
        <tr>
          <td>
            <div class="has-text-weight-normal">
              {{ $t("smartReport.sessionTwoName") }}:<span
                class="has-text-weight-light"
              >
                {{ dataReport.company.name }}
                {{ dataReport.company.surname }}</span
              >
            </div>
            <div class="has-text-weight-normal">
              {{ $t("smartReport.sessionTwoPosition") }}:<span
                class="has-text-weight-light"
              >
                {{ dataReport.company.position }}</span
              >
            </div>
            <div class="has-text-weight-normal">
              {{ $t("smartReport.sessionTwPhoneNo") }}:<span
                class="has-text-weight-light"
              >
                {{ dataReport.company.mobilePhone }}</span
              >
            </div>
            <div class="has-text-weight-normal">
              {{ $t("smartReport.sessionTwoEmail") }}:<span
                class="has-text-weight-light"
              >
                {{ dataReport.company.email }}</span
              >
            </div>
          </td>
        </tr>
      </table>
      <div class="mg-y-15 page-break">
        <p class="bg-title-report">
          <span>{{ $t("smartReport.sessionThree") }}</span>
        </p>
      </div>
      <table>
        <tr>
          <td>
            <h5 class="mg-t-0 has-text-weight-normal is-size-6">
              {{ $t("smartReport.sessionThreeDescribe") }}:
            </h5>
            <div class="mg-b-20">
              <p v-if="dataReport.descriptProduct">
                {{ dataReport.descriptProduct }}
              </p>
              <p
                v-else
                class="has-text-grey is-size-6 th column is-padding-x has-text-centered has-text-centered"
              >
                *** {{ $t("smartReport.notFound") }} ***
              </p>
            </div>
            <h5 class="has-text-weight-normal is-size-6">
              {{ $t("smartReport.sessionThreeType") }}:
            </h5>
            <div class="mg-b-20">
              <p v-if="dataReport.styleTech">{{ dataReport.styleTech }}</p>
              <p
                v-else
                class="has-text-grey is-size-6 th column is-padding-x has-text-centered has-text-centered"
              >
                *** {{ $t("smartReport.notFound") }} ***
              </p>
            </div>
            <h5 class="has-text-weight-normal is-size-6">
              {{ $t("smartReport.sessionThreeBenefits") }}:
            </h5>
            <div class="mg-b-10">
              <p v-if="dataReport.benefitString">
                {{ dataReport.benefitString }}
              </p>
              <p
                v-else
                class="has-text-grey is-size-6 th column is-padding-x has-text-centered has-text-centered"
              >
                *** {{ $t("smartReport.notFound") }} ***
              </p>
            </div>
          </td>
        </tr>
      </table>
      <div class="mg-y-25">
        <p class="bg-title-report">
          <span>{{ $t("smartReport.sessionFour") }}</span>
        </p>
      </div>
      <table class="showTable">
        <tr>
          <td class="has-text-centered font-weight-bold">
            {{ $t("smartReport.sessionFourKPI") }}
          </td>
          <td class="has-text-centered">
            {{ $t("smartReport.sessionFourBeforJoin") }}
          </td>
          <td class="has-text-centered">
            {{ $t("smartReport.sessionFourCurrent") }}
          </td>
        </tr>
        <tr v-for="data in dataReport.dataKpi">
          <td style="width: 250px">{{ data.title }}</td>
          <td style="width: 250px" class="has-text-right">
            <span
              v-if="
                data.start != '' &&
                data.start != null &&
                typeof data.start != 'undefined'
              "
            >
              {{ data.start | commaNumber }}
            </span>
            <span v-else>- </span>
          </td>
          <td style="width: 250px" class="has-text-right">
            <span
              v-if="
                data.end != '' &&
                data.end != null &&
                typeof data.end != 'undefined'
              "
            >
              {{ data.end | commaNumber }}
            </span>
            <span v-else>- </span>
          </td>
        </tr>
      </table>
      <div class="mg-y-25">
        <p class="bg-title-report">
          <span>{{ $t("smartReport.sessionFive") }}</span>
        </p>
      </div>
      <table>
        <tr>
          <td>
            <p class="has-text-weight-normal showPrint">
              {{ $t("smartReport.sessionFiveOverAll") }}:
              {{ getAllCategory(dataReport.activityCategory) }}
              {{ $t("smartReport.sessionFiveCategoriesCount") }} /
              {{ getAllActivity(dataReport.activityCategory) }}
              {{ $t("smartReport.sessionFiveMainActivity") }} /
              {{ getAllTask(dataReport.activityCategory) }}
              {{ $t("smartReport.sessionFiveSubActivity") }}
            </p>
          </td>
        </tr>
        <tr v-if="getAllTask(dataReport.activityCategory) !== 0">
          <td>{{ $t("smartReport.sessionFiveDetail") }}</td>
        </tr>
      </table>
      <table
        v-if="getAllTask(dataReport.activityCategory) !== 0"
        class="showTable"
      >
        <tr>
          <th style="width: 250px" class="has-text-centered">
            {{ $t("smartReport.sessionFiveCategories") }}
          </th>
          <th style="width: 250px" class="has-text-centered">
            {{ $t("smartReport.sessionFiveActivityCount") }}
          </th>
          <th style="width: 250px" class="has-text-centered">
            {{ $t("smartReport.sessionFiveSubActivityCount") }}
          </th>
        </tr>
        <tr
          :key="index"
          v-for="(data, index, value) in dataReport.activityCategory"
          v-if="data.length > 0"
        >
          <td style="width: 250px">{{ getCategoryNameReplace(index) }}</td>
          <td style="width: 250px" class="has-text-centered">
            {{ data.length }}
          </td>
          <td style="width: 250px" class="has-text-centered">
            {{ countTask(data) }}
          </td>
        </tr>
      </table>
      <div class="page-break">
        <p class="bg-title-report">
          <span>{{ $t("smartReport.sessionSix") }}</span>
        </p>
      </div>
      <div class="pd-y-0 mg-b-0 is-12 has-text-right">
        <span class="has-text-grey is-size-7 mg-l-5">
          <i
            >{{ $t("message.updatedAt") }}
            {{ dateFomatActivity(dataReport.rangeEndDate) }}</i
          >
        </span>
      </div>
      <table>
        <tr>
          <td>
            <p class="has-text-weight-normal showPrint">
              {{ $t("smartReport.sessionSixHeader") }}
              {{ dateFomat(dataReport.rangeStartDate) }}
              {{ $t("smartReport.to") }}
              {{ dateFomat(dataReport.rangeEndDate) }}
            </p>
            <div class="has-text-weight-light has-text-weight-normal showPrint">
              <span class=""
                >{{ $t("smartReport.sessionSixSummaryResult") }}:&nbsp;</span
              >
              <span v-if="dataReport.taskLength > 0">{{
                dataReport.reportList.length
              }}</span
              ><span v-else>0</span>
              {{ $t("smartReport.sessionSixCategoriesCount") }} /
              {{ dataReport.activitiesLength }}
              {{ $t("smartReport.sessionSixMainActivity") }} /
              {{ dataReport.taskLength }}
              {{ $t("smartReport.sessionSixSubActivity") }}
            </div>
            <div class="mg-b-10 has-text-weight-normal showPrint">
              {{ $t("smartReport.sessionSixSubHeader") }}
              {{ dataReport.taskLength }}
              {{ $t("smartReport.sessionSixSubActivity") }}
            </div>
          </td>
        </tr>
      </table>
      <table class="showTable mg-b-20">
        <tr>
          <th style="width: 250px" class="has-text-centered">
            {{ $t("smartReport.sessionSixSubHeader") }}
          </th>
          <th style="width: 500px" class="has-text-centered">
            {{ $t("smartReport.sessionSixSubActivity") }}
          </th>
        </tr>
        <tr>
          <td style="width: 250px" class="has-text-centered">
            {{ $t("smartReport.sessionSixPlan") }}
          </td>
          <td style="width: 500px" class="has-text-centered">
            {{ dataReport.plan }}
          </td>
        </tr>
        <tr>
          <td style="width: 250px" class="has-text-centered">
            {{ $t("smartReport.sessionSixInprocess") }}
          </td>
          <td style="width: 500px" class="has-text-centered">
            {{ dataReport.inprocess }}
          </td>
        </tr>
        <tr>
          <td style="width: 250px" class="has-text-centered">
            {{ $t("smartReport.sessionSixDone") }}
          </td>
          <td style="width: 500px" class="has-text-centered">
            {{ dataReport.done }}
          </td>
        </tr>

        <tr>
          <td style="width: 250px" class="has-text-centered">
            {{ $t("smartReport.sessionSixSummary") }}
          </td>
          <td style="width: 500px" class="has-text-centered">
            {{
              dataReport.overdue +
              dataReport.done +
              dataReport.inprocess +
              dataReport.plan
            }}
          </td>
        </tr>
      </table>
      <div class="is-size-5 mg-b-10">
        {{ $t("smartReport.sessionSixSummaryInprocess") }}
      </div>
      <div
        v-if="AmountTaskInActivity(dataInprocess) == 0"
        class="is-size-5 th mg-y-25 pd-l-20 has-text-centered"
        style="color: #ccc"
      >
        *** {{ $t("smartReport.notFound") }} ***
      </div>
      <div
        v-for="(data, index) in dataInprocess"
        class="mg-b-20"
        v-if="getTaskDone(data.activities) > 0"
      >
        <span class="font-weight-nomal mg-b-10"
          >{{ $t("smartReport.sessionSixSummaryCategory") }}:
        </span>
        {{ getCategoryName(data.categoryid) }}

        <table class="showTable mg-t-15">
          <tr>
            <th style="width: 250px" class="has-text-centered">
              {{ $t("smartReport.sessionSixSummaryActivities") }}
            </th>
            <th style="width: 500px" class="has-text-centered">
              {{ $t("smartReport.sessionSixSummaryDetails") }}
            </th>
          </tr>
          <tr v-for="(item, num) in filterDataActivities(data.activities)">
            <td style="width: 250px" class="has-text-centered">
              {{ num + 1 }}
            </td>
            <td style="width: 500px" class="">
              {{ item.activityName }}<br />({{
                checkInProcessOverdue(item.task)
              }})
            </td>
          </tr>
        </table>
      </div>
      <table>
        <table>
          <tr class="is-size-5 mg-t-0">
            {{
              $t("smartReport.sessionSixSummaryDone")
            }}
          </tr>
          <tr
            v-if="AmountTaskInActivity(dataDone) == 0"
            class="is-size-5 th mg-y-25 pd-l-20 has-text-centered"
            style="color: #ccc"
          >
            ***
            {{
              $t("smartReport.notFound")
            }}
            ***
          </tr>
          <tr
            v-for="(data, index) in dataDone"
            class="mg-b-35"
            v-if="getTaskDone(data.activities) > 0"
          >
            <div>
              <p class="has-text-weight-normal">
                {{ $t("smartReport.sessionSixSummaryCategory") }}:
                {{ getCategoryName(data.categoryid) }}:
                <span class="has-text-grey"
                  >{{ getActivityDone(data.activities) }}
                  {{ $t("smartReport.sessionSixMainActivity") }}
                  {{ $t("smartReport.and") }}
                  {{ getTaskDone(data.activities) }}
                  {{ $t("smartReport.sessionSixSubActivity") }}</span
                >
              </p>
            </div>
            <div
              v-for="(item, num) in data.activities"
              v-if="item.task.length > 0"
              class="mg-b-10"
            >
              <tr>
                <div>
                  <p class="mg-b-10">
                    {{ $t("smartReport.sessionSixMainActivity") }}:
                    {{ item.activityName }}
                  </p>
                </div>
              </tr>
              <table v-for="(task, key) in item.task">
                <tr>
                  <td>
                    <div class="borderSize mg-r-20 mg-b-20 overflow-hidden">
                      <img
                        src="@/assets/logo-integreat.png"
                        v-if="task.thumbnail == ''"
                        alt=""
                      />
                      <img
                        style="max-width: 180px; max-height: 180px"
                        alt=""
                        v-else
                        class=""
                        :src="imgUrlThumbNail + task.thumbnail"
                      />
                    </div>
                  </td>
                  <td>
                    <div class="has-text-grey">
                      {{ $t("smartReport.sessionSixSubActivity") }}
                      {{ key + 1 }}:<span
                        class="has-text-dark has-text-weight-normal"
                      >
                        {{ task.name }}</span
                      >
                      {{ checkOverDue(task) }}
                    </div>
                    <div class="has-text-grey">
                      {{
                        $t("smartReport.sessionSixSummaryDoneStartDate")
                      }}:<span class="has-text-dark has-text-weight-normal">
                        {{ dateFomat(task.startDate) }}</span
                      >
                    </div>
                    <div class="has-text-grey">
                      {{
                        $t("smartReport.sessionSixSummaryDoneDateComplete")
                      }}:<span class="has-text-dark has-text-weight-normal">
                        {{ dateFomat(task.endDate) }}</span
                      >
                    </div>
                    <div class="has-text-grey mg-b-20">
                      {{ $t("smartReport.sessionSixSummaryResult") }}:<span
                        class="has-text-dark has-text-weight-normal"
                      >
                        {{ task.descriptionDone }}</span
                      >
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </tr>
        </table>
      </table>
      <div class="mg-y-25 page-break">
        <p class="bg-title-report">
          <span>{{ $t("smartReport.sessionSeven") }}</span>
        </p>
      </div>
      <div
        v-if="dataReport.nextActivity.length == 0"
        class="is-size-5 th mg-y-25 pd-l-20 has-text-centered"
        style="color: #ccc"
      >
        *** {{ $t("smartReport.notFound") }} ***
      </div>
      <div v-for="(data, index) in dataReport.nextActivity" class="showTable">
        <p class="mg-b-10">
          <span class="font-weight-nomal"
            >{{ $t("smartReport.sessionSevenSummaryCategory") }}: </span
          >{{ getCategoryName(data.categoryid) }}
        </p>
        <table class="showTable mg-b-20">
          <tr>
            <td class="has-text-centered">
              {{ $t("smartReport.sessionSevenSummaryActivities") }}
            </td>
            <td class="has-text-centered">
              {{ $t("smartReport.sessionSevenSummaryDetails") }}
            </td>
          </tr>
          <tr v-for="(item, num) in data.activities">
            <td style="width: 80px" class="has-text-centered">{{ num + 1 }}</td>
            <td style="width: 700px">
              {{ item.activityName }}<br />({{ item.tasks }}
              {{ $t("smartReport.sessionSixSubActivity") }})
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { HTTP, HTTPDynamic } from "../axios.js";
import momentTH from "moment/src/locale/th";
import moment from "moment";
export default {
  data() {
    return {
      isLoadingPage: true,
      baseUrl: process.env.VUE_APP_BASE_URL,
      isLoadingData: false,
      dataKpi: [],
      category: 0,
      activity: 0,
      task: 0,
      reportList: [],
      taskInprocess: [],
      imgUrl: process.env.VUE_APP_IMAGE_URL,
      imgUrlUnder: process.env.VUE_APP_IMAGE_URL_UNDER,
      imgUrlThumbNail: process.env.VUE_APP_IMAGE_THUMBNAIL,
      organizeName: "",
      under: "",
      dateNow: new Date(),
      kpiStart: "",
      kpiEnd: "",
      dataForm: {},
      companyDateRegister: "",
      CompanyRegistrationNumber: "",
      companyFund: "",
      descriptProduct: "",
      styleTech: "",
      benefitString: "",
      reportInprocess: [],
      nextActivity: [],
      allScience: "",
    };
  },
  created() {
    // await this.fetchData()
    this.getUnder();
    this.getAllScience();
    // setTimeout(()=>{
    // 	window.print()
    // },2000)
  },
  computed: {
    dataInprocess() {
      let json = JSON.stringify(this.dataReport.reportInprocess);
      let dataValue = JSON.parse(json);
      dataValue.map((data, key) => {
        data.activities.map((value, num) => {
          let filterTask = value.task.filter((search) => {
            return search.status == 2;
          });
          value.task = filterTask;
        });
      });
      //console.log('checkTaskInprocess after',dataValue)
      return dataValue;
    },
    dataDone() {
      let json = JSON.stringify(this.dataReport.reportList);
      let dataValue = JSON.parse(json);
      dataValue.map((data, key) => {
        data.activities.map((value, num) => {
          let filterTask = value.task.filter((search) => {
            return search.status == 3;
          });
          value.task = filterTask;
        });
      });
      //console.log('checkTaskDone after',dataValue)
      return dataValue;
    },
    spaPage() {
      return this.$store.state.spaPage;
    },
    reportId() {
      return this.$store.state.report;
    },
    token() {
      return this.$store.state.token;
    },
    businessIncubator() {
      return this.$store.state.businessIncubator;
    },
    supportAgencies() {
      return this.$store.state.supportAgencies;
    },
    getRule() {
      return this.$store.state.rule;
    },
    user() {
      return this.$store.state.user;
    },
    batch() {
      return this.$store.state.batch;
    },
    token() {
      return this.$store.state.token;
    },
    businessType() {
      let data = this.$store.state.businessType.filter(
        (item) => item.id == this.dataReport.company.typeOfBusiness
      );
      if (data.length > 0) {
        return data[0].name;
      } else {
        return "";
      }
    },
    levelOfbusiness() {
      let data = this.$store.state.projectLevel.filter(
        (item) => item.id == this.dataReport.company.levelOfbusiness
      );
      if (data.length > 0) {
        return data[0].name;
      } else {
        return "";
      }
    },
    dataReport() {
      return this.$store.state.dataReport;
    },
    businessLevel() {
      if (this.batch.levelType === 1) {
        return this.$store.state.projectLevel;
      } else if (this.batch.levelType === 2) {
        return this.$store.state.businessLevel;
      } else if (this.batch.levelType === 3) {
        return this.$store.state.technologyLevel;
      } else {
        return [];
      }
    },
  },
  methods: {
    filterDataActivities(data) {
      let dataActivities = data.filter((item) => {
        return item.task.length > 0;
      });
      return dataActivities;
    },
    AmountTaskInActivity(value) {
      let amount = 0;
      value.map((data) => {
        data.activities.map((activity) => {
          amount += activity.task.length;
        });
      });
      return amount;
    },
    checkInProcessOverdue(task) {
      let inpro = 0;
      let over = 0;
      task.map((data) => {
        if (new Date(task.finishProcessDate) > new Date(task.endDate)) {
          over = over + 1;
        } else {
          inpro = inpro + 1;
        }
      });
      if (inpro > 0 && over == 0) {
        return inpro + " กิจกรรมย่อย";
      } else if (inpro == 0 && over > 0) {
        return over + " กิจกรรมย่อย(ล่าช้า)";
      } else {
        return inpro + " กิจกรรมย่อย " + over + " กิจกรรมย่อย(ล่าช้า)";
      }
    },
    checkOverDue(task) {
      //console.log(task)
      if (new Date(task.finishProcessDate) > new Date(task.endDate)) {
        return "(ล่าช้า)";
      } else {
        return "";
      }
    },
    countTask(value) {
      let data = 0;
      value.map((item, index) => {
        data += item.countTask;
      });
      return data;
    },
    prevPage(url) {
      this.$router.push(url);
    },
    getTaskDone(data) {
      let number = 0;
      data.map((item) => {
        if (item.task.length > 0) {
          number = number + item.task.length;
        }
      });
      return number;
      //console.log('getTaskDone',number)
    },
    getActivityDone(data) {
      let number = 0;
      data.map((item) => {
        if (item.task.length > 0) {
          number = number + 1;
        }
      });
      return number;
    },
    getUnder() {
      let data;
      if (this.getRule === "startup" || this.getRule === "staff") {
        data = {
          underId: this.reportId.underId,
        };
      } else {
        data = {
          underId: this.user.under,
        };
      }
      //console.log(data)
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post("/api/get/under/by/id", data).then((result) => {
        //console.log('/api/get/under/by/id',result)
        this.under = result.data;
      });
    },
    getCategoryNameReplace(id) {
      let str;
      let dataCat;
      str = id.replace("id", "");
      dataCat = this.businessIncubator.filter((item) => item.id == str);
      if (dataCat.length == 0) {
        dataCat = this.supportAgencies.filter((item) => item.id == str);
      }
      if (dataCat.length > 0) {
        return dataCat[0].name;
      } else {
        return "";
      }
    },
    getCategoryName(id) {
      let dataCat;

      dataCat = this.businessIncubator.filter((item) => item.id == id);
      if (dataCat.length == 0) {
        dataCat = this.supportAgencies.filter((item) => item.id == id);
      }
      if (dataCat.length > 0) {
        return dataCat[0].name;
      } else {
        return "";
      }
    },
    checkTaskInprocess(report) {
      let dataValue = report;
      dataValue.map((data, key) => {
        data.activities.map((value, num) => {
          value.task.map((item, index) => {
            if (item.status == 1 || item.status == 3) {
              value.task.splice(index, 1);
            }
          });
          // if(value.task.length == 0){
          // 	dataValue.splice(key,1)
          // }
        });
      });
      //console.log('checkTaskInprocess after',dataValue)
      return dataValue;
    },
    checkTaskDone(report) {
      //console.log(report)
      let json = JSON.stringify(report);
      let dataValue = JSON.parse(json);
      dataValue.map((data, key) => {
        data.activities.map((value, num) => {
          value.task.map((item, index) => {
            if (item.status == 2 || item.status == 4 || item.status == 1) {
              value.task.splice(index, 1);
            }
            // if(value.task.length == 0){
            // 	dataValue.splice(key,1)
            // }
          });
        });
      });
      //console.log('checkTaskDone after',dataValue)
      return dataValue;
    },
    getListByCatId() {
      this.reportList = [];
      this.reportInprocess = [];
      var i;
      for (i = 1; i <= 34; i++) {
        let dataList = this.dataReport.activities.filter((search) => {
          return search.categoryId == i;
        });

        if (dataList.length > 0) {
          dataList.map((data, key) => {
            if (key == 0) {
              var myJSON = JSON.stringify(dataList);
              this.reportList.push({
                categoryid: i,
                activities: JSON.parse(myJSON),
              });
              this.reportInprocess.push({
                categoryid: i,
                activities: JSON.parse(myJSON),
              });
            }
          });
        }
        let dataActivty = this.dataReport.activitiesPlan.filter((search) => {
          return search.cateId == i;
        });
        if (dataActivty.length > 0) {
          this.nextActivity.push({ categoryid: i, activities: dataActivty });
        }
      }
      setTimeout(() => {
        this.isLoadingData = true;
      }, 1000);
      //console.log('this.reportList',this.reportList)
      //console.log('this.reportInprocess',this.reportInprocess)
    },
    getAllScience() {
      if (this.getRule == "exclusiveboard" || this.getRule == "board") {
        HTTP.post("get/all/science/park").then((result) => {
          //console.log('get/all/science/park',result)
          let data = result.data.obj.filter((search) => {
            return search._id == this.reportId.scienceParkId;
          });
          if (data.length > 0) {
            this.allScience = data[0];
          }
        });
      }
    },
    getTaskLength(value) {
      let numTask = 0;
      value.map((item) => {
        numTask = numTask + item.countTask;
      });
      return numTask;
    },
    onPrint() {
      this.$router.push("/print-report");
    },
    formatTime(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "";
      } else {
        res = moment(moment(date).locale("th", momentTH).add(543, "y")).format(
          "DD MMMM Y HH:mm "
        );
      }
      return res;
    },
    dateFomat(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "";
      } else {
        res = moment(moment(date).locale("th", momentTH).add(543, "y")).format(
          "DD MMMM Y "
        );
      }
      return res;
    },
    dateFomatActivity(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "";
      } else {
        res = moment(
          moment(date).add(-1, "days").locale("th", momentTH).add(543, "y")
        ).format("DD MMMM Y 23.59");
      }
      return res;
    },
    getLevelOfBusiness(id) {
      let filter = this.businessLevel.filter((filter) => filter.id === id);
      if (filter.length > 0) {
        return filter[0].name;
      } else {
        return "-";
      }
    },

    getAllCategory(value) {
      let num = 0;
      var i;
      for (i = 1; i <= 34; i++) {
        switch (i) {
          case 1:
            if (value.id1.length > 0) {
              num += 1;
            }
            break;
          case 2:
            if (value.id2.length > 0) {
              num += 1;
            }
            break;
          case 3:
            if (value.id3.length > 0) {
              num += 1;
            }
            break;
          case 4:
            if (value.id4.length > 0) {
              num += 1;
            }
            break;
          case 5:
            if (value.id5.length > 0) {
              num += 1;
            }
            break;
          case 6:
            if (value.id6.length > 0) {
              num += 1;
            }
            break;
          case 7:
            if (value.id7.length > 0) {
              num += 1;
            }
            break;
          case 8:
            if (value.id8.length > 0) {
              num += 1;
            }
            break;
          case 9:
            if (value.id9.length > 0) {
              num += 1;
            }
            break;
          case 10:
            if (value.id10.length > 0) {
              num += 1;
            }
            break;
          case 11:
            if (value.id11.length > 0) {
              num += 1;
            }
            break;
          case 12:
            if (value.id12length > 0) {
              num += 1;
            }
            break;
          case 13:
            if (value.id13.length > 0) {
              num += 1;
            }
            break;
          case 14:
            if (value.id14length > 0) {
              num += 1;
            }
            break;
          case 15:
            if (value.id15.length > 0) {
              num += 1;
            }
            break;
          case 16:
            if (value.id16.length > 0) {
              num += 1;
            }
            break;
          case 17:
            if (value.id17.length > 0) {
              num += 1;
            }
            break;
          case 18:
            if (value.id18.length > 0) {
              num += 1;
            }
            break;
          case 19:
            if (value.id19.length > 0) {
              num += 1;
            }
            break;
          case 20:
            if (value.id20.length > 0) {
              num += 1;
            }
            break;
          case 21:
            if (value.id21.length > 0) {
              num += 1;
            }
            break;
          case 22:
            if (value.id22.length > 0) {
              num += 1;
            }
            break;
          case 23:
            if (value.id23.length > 0) {
              num += 1;
            }
            break;
          case 24:
            if (value.id24.length > 0) {
              num += 1;
            }
            break;
          case 25:
            if (value.id23.length > 0) {
              num += 1;
            }
            break;
          case 26:
            if (value.id26.length > 0) {
              num += 1;
            }
            break;
          case 27:
            if (value.id27.length > 0) {
              num += 1;
            }
            break;
          case 28:
            if (value.id28.length > 0) {
              num += 1;
            }
            break;
          case 29:
            if (value.id29.length > 0) {
              num += 1;
            }
            break;
          case 30:
            if (value.id30.length > 0) {
              num += 1;
            }
            break;
          case 31:
            if (value.id31.length > 0) {
              num += 1;
            }
            break;
          case 32:
            if (value.id32.length > 0) {
              num += 1;
            }
            break;
          case 33:
            if (value.id33.length > 0) {
              num += 1;
            }
            break;
          case 34:
            if (value.id34.length > 0) {
              num += 1;
            }
            break;
          default:
            break;
        }
      }
      return num;
    },
    getAllActivity(value) {
      let num = 0;
      var i;
      for (i = 1; i <= 34; i++) {
        switch (i) {
          case 1:
            if (value.id1.length > 0) {
              num += value.id1.length;
            }
            break;
          case 2:
            if (value.id2.length > 0) {
              num += value.id2.length;
            }
            break;
          case 3:
            if (value.id3.length > 0) {
              num += value.id3.length;
            }
            break;
          case 4:
            if (value.id4.length > 0) {
              num += value.id4.length;
            }
            break;
          case 5:
            if (value.id5.length > 0) {
              num += value.id5.length;
            }
            break;
          case 6:
            if (value.id6.length > 0) {
              num += value.id6.length;
            }
            break;
          case 7:
            if (value.id7.length > 0) {
              num += value.id7.length;
            }
            break;
          case 8:
            if (value.id8.length > 0) {
              num += value.id8.length;
            }
            break;
          case 9:
            if (value.id9.length > 0) {
              num += value.id9.length;
            }
            break;
          case 10:
            if (value.id10.length > 0) {
              num += value.id10.length;
            }
            break;
          case 11:
            if (value.id11.length > 0) {
              num += value.id11.length;
            }
            break;
          case 12:
            if (value.id12length > 0) {
              num += value.id12.length;
            }
            break;
          case 13:
            if (value.id13.length > 0) {
              num += value.id13.length;
            }
            break;
          case 14:
            if (value.id14length > 0) {
              num += value.id14.length;
            }
            break;
          case 15:
            if (value.id15.length > 0) {
              num += value.id15.length;
            }
            break;
          case 16:
            if (value.id16.length > 0) {
              num += value.id16.length;
            }
            break;
          case 17:
            if (value.id17.length > 0) {
              num += value.id17.length;
            }
            break;
          case 18:
            if (value.id18.length > 0) {
              num += value.id18.length;
            }
            break;
          case 19:
            if (value.id19.length > 0) {
              num += value.id19.length;
            }
            break;
          case 20:
            if (value.id20.length > 0) {
              num += value.id20.length;
            }
            break;
          case 21:
            if (value.id21.length > 0) {
              num += value.id21.length;
            }
            break;
          case 22:
            if (value.id22.length > 0) {
              num += value.id22.length;
            }
            break;
          case 23:
            if (value.id23.length > 0) {
              num += value.id23.length;
            }
            break;
          case 24:
            if (value.id24.length > 0) {
              num += value.id24.length;
            }
            break;
          case 25:
            if (value.id25.length > 0) {
              num += value.id25.length;
            }
            break;
          case 26:
            if (value.id26.length > 0) {
              num += value.id26.length;
            }
            break;
          case 27:
            if (value.id27.length > 0) {
              num += value.id27.length;
            }
            break;
          case 28:
            if (value.id28.length > 0) {
              num += value.id28.length;
            }
            break;
          case 29:
            if (value.id29.length > 0) {
              num += value.id29.length;
            }
            break;
          case 30:
            if (value.id30.length > 0) {
              num += value.id30.length;
            }
            break;
          case 31:
            if (value.id31.length > 0) {
              num += value.id31.length;
            }
            break;
          case 32:
            if (value.id32.length > 0) {
              num += value.id32.length;
            }
            break;
          case 33:
            if (value.id33.length > 0) {
              num += value.id33.length;
            }
            break;
          case 34:
            if (value.id34.length > 0) {
              num += value.id34.length;
            }
            break;
          default:
            break;
        }
      }
      return num;
    },
    getAllTask(value) {
      let num = 0;
      var i;
      for (i = 1; i <= 34; i++) {
        switch (i) {
          case 1:
            if (value.id1.length > 0) {
              value.id1.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 2:
            if (value.id2.length > 0) {
              value.id2.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 3:
            if (value.id3.length > 0) {
              value.id3.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 4:
            if (value.id4.length > 0) {
              value.id4.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 5:
            if (value.id5.length > 0) {
              value.id5.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 6:
            if (value.id6.length > 0) {
              value.id6.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 7:
            if (value.id7.length > 0) {
              value.id7.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 8:
            if (value.id8.length > 0) {
              value.id8.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 9:
            if (value.id9.length > 0) {
              value.id9.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 10:
            if (value.id10.length > 0) {
              value.id10.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 11:
            if (value.id11.length > 0) {
              value.id11.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 12:
            if (value.id12length > 0) {
              value.id12.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 13:
            if (value.id13.length > 0) {
              value.id13.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 14:
            if (value.id14length > 0) {
              value.id14.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 15:
            if (value.id15.length > 0) {
              value.id15.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 16:
            if (value.id16.length > 0) {
              value.id16.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 17:
            if (value.id17.length > 0) {
              value.id17.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 18:
            if (value.id18.length > 0) {
              value.id18.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 19:
            if (value.id19.length > 0) {
              value.id19.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 20:
            if (value.id20.length > 0) {
              value.id20.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 21:
            if (value.id21.length > 0) {
              value.id21.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 22:
            if (value.id22.length > 0) {
              value.id22.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 23:
            if (value.id23.length > 0) {
              value.id23.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 24:
            if (value.id24.length > 0) {
              value.id24.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 25:
            if (value.id25.length > 0) {
              value.id25.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 26:
            if (value.id26.length > 0) {
              value.id26.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 27:
            if (value.id27.length > 0) {
              value.id27.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 28:
            if (value.id28.length > 0) {
              value.id28.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 29:
            if (value.id29.length > 0) {
              value.id29.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 30:
            if (value.id30.length > 0) {
              value.id30.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 31:
            if (value.id31.length > 0) {
              value.id31.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 32:
            if (value.id32.length > 0) {
              value.id32.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 33:
            if (value.id33.length > 0) {
              value.id33.map((item) => {
                num += item.countTask;
              });
            }
            break;
          case 34:
            if (value.id34.length > 0) {
              value.id34.map((item) => {
                num += item.countTask;
              });
            }
            break;
          default:
            break;
        }
      }
      return num;
    },
  },
};
</script>
<style scoped>
.is-12 {
  display: inline-block;
  width: 100%;
  padding: 5px;
}
.is-9 {
  display: inline-block;
  width: 75%;
  padding: 5px;
}
.is-3 {
  display: inline-block;
  width: 25%;
  padding: 5px;
}
@page {
  size: A4;
  margin-bottom: 10mm;
  padding-bottom: 10mm;
}
.d-block {
  display: block !important;
}

@media print {
  .borderSize {
    width: 180px;
    height: 180px;
  }
  h2 {
    page-break-before: always;
  }
  h3,
  h4 {
    page-break-after: avoid;
  }
  pre,
  blockquote,
  span,
  a {
    page-break-inside: avoid;
  }
  * {
    float: none !important;
  }
  p,
  img {
    display: block;
    page-break-inside: avoid;
  }
  tr,
  td {
    font-size: 14px !important;
  }
  td {
    padding: 5px;
  }
  table {
    display: block !important;
    width: 100%;
    page-break-inside: avoid;
  }

  .d-block {
    page-break-after: avoid;
  }
  .page-break {
    display: block;
    page-break-before: always;
  }
  .resize-img {
    width: unset;
    height: unset;
    display: inline-block;
  }
  table {
    width: 100%;
  }
  table tr td {
    padding: 4px !important;
  }
  table.showTable tr th {
    border: 1px solid #dbdbdb !important;
    font-weight: 400 !important;
    padding: 2px;
  }
  table.showTable tr td {
    border: 1px solid #dbdbdb !important;
    padding: 2px;
  }
  .border-kpi table td,
  .border-kpi table th {
    border-width: 1px !important;
  }
  .border-kpi table tr td {
    font-size: 14px;
    border: 1px solid #dbdbdb !important;
    padding: 2px;
  }
  .content table tfoot td,
  .content table tfoot th {
    border: 0px solid #dbdbdb !important;
  }
  .footer-space {
    border-top: 1px solid #ebebeb !important;
    height: 70px !important;
  }
  .is-flex-wrap {
    display: block !important;
    flex-wrap: unset !important;
  }
  .is-flex {
    display: block !important;
  }
  body {
    margin: 0;
  }
  p {
    font-size: 14px !important;
  }
  h2 {
    font-size: 16px !important;
  }
  .print-mg-auto {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .detail-table {
    border-radius: 0 !important;
    border: 0px #fff !important;
  }
  .detail-table,
  .head-table {
    margin: 0 !important;
  }
  .bg-title-report {
    position: relative !important;
  }
  .bg-title-report span {
    background-color: #00a79d !important;
    display: inline-block !important;
    padding: 5px 15px !important;
    color: #fff !important;
    position: relative !important;
    z-index: 1 !important;
  }
  .bg-title-report:after {
    content: "";
    width: 100% !important;
    height: 2px !important;
    background-color: #00a79d !important;
    position: absolute !important;
    top: 45% !important;
    z-index: 0 !important;
    left: 0 !important;
  }
  .page {
    margin: 0 0 80px 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
  }
  .pd-15 {
    padding: 0 !important;
  }
  .column.disablePrint {
    display: none !important;
  }
  .column {
    display: inline-block !important;
  }
  .detail-table {
    width: 100% !important;
    border: 0px;
    padding: 0 !important;
  }
}
.printPage {
  opacity: 0.6;
  bottom: 40px;
  right: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  border-radius: 100%;
  font-size: 25px;
  width: 70px;
  height: 70px;
  color: #fff;
  z-index: 10000;
  background: rgba(109, 141, 243, 0.9);
}
.bg-title-report {
  position: relative;
}
.bg-title-report span {
  background-color: #00a79d;
  display: inline-block;
  padding: 5px 15px;
  color: #fff;
  position: relative;
  z-index: 1;
}
.bg-title-report:after {
  content: "";
  width: 100%;
  height: 2px;
  background-color: #00a79d;
  position: absolute;
  top: 45%;
  z-index: 0;
  left: 0;
}
.text-report .column {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
</style>